import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CoreLookUpService {
    addCoreFormData= new Subject();
    getCoreReports = `mycore/coreSearch`;
    constructor(private http: HttpClient, private occService: OccEndpointsService) { }

    getDocsApi() {
        return this.http.get(this.occService.buildUrl(`core/corelookup`));
    }
    search1(query, currentPage, pageName) {
        return this.http.get(this.occService.buildUrl(`core/corelookup/search?code=${query}&page=${currentPage}&pageName=${pageName}`));
    }
    search2(query, currentPage) {
        return this.http.get(this.occService.buildUrl(`core/corelookup/groupsearch?code=${query}&page=${currentPage}`));
    }

    getCoreSearchData() {
        return this.http.get(this.occService.buildUrl(`mycore/coreSearch`));
    }
    postCoreSearchData(formData, currentPage?, sortType?) {
        return this.http.post(
            this.occService.buildUrl(`mycore/coresearch?currentPage=${currentPage}&sort=${sortType}`), formData);
    }
    FilePostApi(file) {
        return this.http.post(this.occService.buildUrl(`importorder`), file);
    }
    getApiCoreReports() {
        return this.http.get(this.occService.buildUrl(`mycore/corereports`));
    }
    postApiCoreReports(data) {
        return this.http.post(this.occService.buildUrl(`mycore/corereports`), data);
    }
    // Core Return Request
    getcoresubmit() {
        return this.http.get(this.occService.buildUrl(`mycore/coresubmit`));
    }
    getmycorepopulateAddressSelect(addressList) {
        return this.http.get(this.occService.buildUrl(`mycore/populateAddressSelect?code=${addressList}`));
    }
    getmycorecoreclass(key) {
        return this.http.get(this.occService.buildUrl(`mycore/coreclass?code=${key}`));
    }
    getmycoreweightna(key) {
        return this.http.get(this.occService.buildUrl(`mycore/weightna?code=${key}`));
    }
    postcoreSubmitForm(payload) {
        return this.http.post(this.occService.buildUrl(`mycore/coresubmit`), payload);
    }
    //get reports
    getcorereports() {
        return this.http.get(this.occService.buildUrl(`mycore/corereports`));
    }

    getmyupgradecorecoreclass(key) {
        return this.http.get(this.occService.buildUrl(`mycore/coregrade?code=${key}`));
    }

    getBOLpdf(crm,shipId,payload){
        return this.http.post(this.occService.buildUrl(`mycore/getpdffromargus?crmNumber=${crm}&shipmentId=${shipId}`), payload);
    }

    getSavedCoreDetails(claimNumber){
        return this.http.get(this.occService.buildUrl(`mycore/getsavedcoredata?claimNumber=${claimNumber}`))
    }
}

